import EndPointConfig from "../../models/api/endPointConfig";

const controller = "Configurations";

/// Define all EndPoints for customizations section.
export const ConfigurationsEP: EndPointConfig[] = [
  // Envio de formulario a la API
  new EndPointConfig()
    .setMethod('POST')
    .setController(controller)
    .setActionName('otp')
    .setAlias('UpdateOtpStatus'),
  new EndPointConfig()
    .setMethod('GET')
    .setController(controller)
    .setActionName('TrySendEmailNotification')
    .setAlias('TrySendEmailNotification')
];
